
import { Vue, Component, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import notifications from "@/lib/notifications";
import { InventoryItemListFilters } from "@/models/api/barcodeSystem/inventory/inventoryItems";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import { LinkInventoryRequest } from "@/models/api/barcodeSystem/barcodeOrders/linkInventory";

const inventoryModuleState = getModule(InventoryModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class InventoryItemFilters extends Vue {
  localFilters: InventoryItemListFilters = null;

  @Prop({ default: null })
  linkInventoryRequest: LinkInventoryRequest;

  get filters() {
    return inventoryModuleState.linkItemFilters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  get companyName(): string {
    return this.linkInventoryRequest ? this.linkInventoryRequest.companyName : "";
  }

  set companyName(val: string) {

  }

  async submit() {
    inventoryModuleState.setLinkItemFilters(JSON.parse(JSON.stringify(this.localFilters)));
    inventoryModuleState.setLoading(true);
    try {
      await inventoryModuleState.getInventoryItemsForLinking({
        pageNumber: 1,
        pageSize: inventoryModuleState.linkItemPageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Inventory Items", "Failed to load inventory items", ex);
    }

    inventoryModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return inventoryModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
